import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=594f52dc&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/franciscoriquelme/Documents/Elipse.ia/Proyectos/elipse-citas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('594f52dc')) {
      api.createRecord('594f52dc', component.options)
    } else {
      api.reload('594f52dc', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=594f52dc&", function () {
      api.rerender('594f52dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/GruposWorkers/Index.vue"
export default component.exports